import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertModal({
  text,
  title,
  render,
  hideModal,
  children,
  buttons,
  buttonText,
  buttonAction,
  saveProgress
}) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (render) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  });

  const handleClose = () => {
    if (hideModal) {
      hideModal();
    } else {
      setOpen(false);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {buttons ? buttons : null}
          {/* (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px"
              }}
              onClick={buttonAction || handleClose}
              autoFocus
            >
              {buttonText}
            </Button>
          ) */}
          {}
        </DialogActions>
      </Dialog>
    </div>
  );
}
